import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const TL = (v) => new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',minimumFractionDigits:0}).format(v||0);
const buDonem = () => { const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`; };

export default function EkDersPage() {
  const [ogretmenler, setOgretmenler] = useState([]);
  const [ekDersler, setEkDersler]     = useState([]);
  const [hesap, setHesap]             = useState(null);
  const [loading, setLoading]         = useState(false);
  const [filtre, setFiltre]           = useState({ ogretmen_id:'', donem: buDonem(), onaylandi:'' });
  const [showForm, setShowForm]       = useState(false);
  const [form, setForm]               = useState({ ogretmen_id:'', donem:buDonem(), tarih:new Date().toISOString().slice(0,10), ders_turu:'ek_ders', saat:'1', birim_ucret:'', aciklama:'' });
  const [hesapYukleniyor, setHesapYukleniyor] = useState(false);

  useEffect(() => {
    axios.get('/ogretmenler-listesi').then(r => { if(r.data.success) setOgretmenler(r.data.data||[]); }).catch(()=>{});
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams(Object.fromEntries(Object.entries(filtre).filter(([,v])=>v!=='')));
      const r = await axios.get(`/muhasebe/ek-ders?${params}`);
      if (r.data.success) setEkDersler(r.data.data);
    } catch {} finally { setLoading(false); }
  }, [filtre]);

  useEffect(() => { load(); }, [load]);

  const hesaplaYoklama = async () => {
    if (!filtre.ogretmen_id) { toast.error('Önce öğretmen seçin'); return; }
    setHesapYukleniyor(true);
    try {
      const r = await axios.get(`/muhasebe/ek-ders/yoklama-hesap?ogretmen_id=${filtre.ogretmen_id}&donem=${filtre.donem}`);
      if (r.data.success) setHesap(r.data.data);
    } catch (e) { toast.error('Hesaplanamadı'); }
    finally { setHesapYukleniyor(false); }
  };

  const handleEkle = async () => {
    if (!form.ogretmen_id || !form.saat) { toast.error('Öğretmen ve saat zorunlu'); return; }
    try {
      await axios.post('/muhasebe/ek-ders', form);
      toast.success('Ek ders eklendi');
      setShowForm(false); load();
    } catch (e) { toast.error('Hata'); }
  };

  const handleOnayla = async (id) => {
    try {
      await axios.put(`/muhasebe/ek-ders/${id}/onayla`);
      toast.success('Onaylandı'); load();
    } catch { toast.error('Hata'); }
  };

  const DERS_TURU = { normal:'Normal', etut:'Etüt', ek_ders:'Ek Ders', nobet:'Nöbet', seminer:'Seminer' };
  const DERS_RENK = { normal:'#3B82F6', etut:'#8B5CF6', ek_ders:'#F59E0B', nobet:'#6B7280', seminer:'#10B981' };

  const toplamSaat = ekDersler.filter(e=>e.onaylandi).reduce((s,e)=>s+parseFloat(e.saat),0);
  const toplamTutar = ekDersler.filter(e=>e.onaylandi).reduce((s,e)=>s+parseFloat(e.toplam),0);

  return (
    <div style={{display:'flex',flexDirection:'column',gap:20}}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{fontFamily:'var(--font-ui)',fontWeight:900}}>🏫 Ek Ders Takibi</h2>
          <div className="section-subtitle">Yoklama entegrasyonlu hakediş yönetimi</div>
        </div>
        <button className="btn btn-primary" onClick={()=>setShowForm(s=>!s)}>+ Manuel Ekle</button>
      </div>

      {/* Filtre bar */}
      <div className="card animate-fadeInUp stagger-1 muh-filter-row" style={{padding:'12px 16px',alignItems:'flex-end'}}>
        <div className="form-group" style={{margin:0}}>
          <label className="form-label">Öğretmen</label>
          <select className="form-input" style={{width:200}} value={filtre.ogretmen_id}
            onChange={e=>setFiltre(f=>({...f,ogretmen_id:e.target.value}))}>
            <option value="">Tüm Öğretmenler</option>
            {ogretmenler.map((o,i)=><option key={o.ogretmen_id||o.user_id||i} value={o.ogretmen_id||o.user_id||i}>{o.ad} {o.soyad}</option>)}
          </select>
        </div>
        <div className="form-group" style={{margin:0}}>
          <label className="form-label">Dönem</label>
          <input className="form-input" type="month" style={{width:150}} value={filtre.donem}
            onChange={e=>setFiltre(f=>({...f,donem:e.target.value}))} />
        </div>
        <div className="form-group" style={{margin:0}}>
          <label className="form-label">Onay</label>
          <select className="form-input" style={{width:140}} value={filtre.onaylandi}
            onChange={e=>setFiltre(f=>({...f,onaylandi:e.target.value}))}>
            <option value="">Tümü</option>
            <option value="0">⏳ Bekleyen</option>
            <option value="1">✅ Onaylandı</option>
          </select>
        </div>
        <button className="btn btn-secondary" onClick={hesaplaYoklama} disabled={hesapYukleniyor||!filtre.ogretmen_id}>
          {hesapYukleniyor ? <div className="spinner" style={{width:16,height:16}}/> : '🔄 Yoklamadan Hesapla'}
        </button>
      </div>

      {/* Yoklama bazlı hesaplama sonucu */}
      {hesap && (
        <div className="card animate-fadeInUp" style={{background:'linear-gradient(135deg,#EFF6FF,#DBEAFE)',border:'1.5px solid #3B82F6'}}>
          <div style={{fontFamily:'var(--font-ui)',fontWeight:800,marginBottom:14,color:'#1E40AF'}}>
            📊 {hesap.donem} Dönemi Yoklama Analizi
          </div>
          <div className="muh-grid-3" style={{marginBottom:14}}>
            {[
              {l:'Toplam Yoklama Saati',  v:`${hesap.toplam_yoklama_saat} saat`, c:'#1E40AF'},
              {l:'Normal Ders Saati',     v:`${hesap.normal_ders_saat} saat`,    c:'#6B7280'},
              {l:'Ek Ders Saati',         v:`${hesap.ek_ders_saat} saat`,        c:'#F59E0B'},
            ].map((s,i)=>(
              <div key={i} style={{textAlign:'center',padding:'10px',background:'white',borderRadius:10}}>
                <div style={{fontFamily:'var(--font-ui)',fontWeight:900,color:s.c,fontSize:'1.3rem'}}>{s.v}</div>
                <div style={{fontSize:'0.72rem',color:'var(--text-muted)'}}>{s.l}</div>
              </div>
            ))}
          </div>
          {hesap.ek_ders_saat > 0 && (
            <div style={{background:'rgba(59,130,246,0.1)',borderRadius:10,padding:'10px 14px',fontSize:'0.85rem',color:'#1E40AF'}}>
              ℹ️ Bu dönem <b>{hesap.ek_ders_saat} saat</b> ek ders tespit edildi. 
              Manuel olarak ek ders kaydı ekleyebilir ve maaşa dahil edebilirsiniz.
            </div>
          )}
        </div>
      )}

      {/* Manuel ek ders formu */}
      {showForm && (
        <div className="card animate-fadeInUp" style={{border:'1.5px solid var(--blue)'}}>
          <div style={{fontWeight:800,marginBottom:14}}>+ Manuel Ek Ders Ekle</div>
          <div className="muh-grid-3">
            <div className="form-group">
              <label className="form-label">Öğretmen *</label>
              <select className="form-input" value={form.ogretmen_id} onChange={e=>setForm(f=>({...f,ogretmen_id:e.target.value}))}>
                <option value="">Seçin</option>
                {ogretmenler.map((o,i)=><option key={o.ogretmen_id||o.user_id||i} value={o.ogretmen_id||o.user_id||i}>{o.ad} {o.soyad}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Dönem</label>
              <input className="form-input" type="month" value={form.donem} onChange={e=>setForm(f=>({...f,donem:e.target.value}))} />
            </div>
            <div className="form-group">
              <label className="form-label">Tarih</label>
              <input className="form-input" type="date" value={form.tarih} onChange={e=>setForm(f=>({...f,tarih:e.target.value}))} />
            </div>
            <div className="form-group">
              <label className="form-label">Ders Türü</label>
              <select className="form-input" value={form.ders_turu} onChange={e=>setForm(f=>({...f,ders_turu:e.target.value}))}>
                {Object.entries(DERS_TURU).map(([v,l])=><option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Saat *</label>
              <input className="form-input" type="number" step="0.5" value={form.saat} onChange={e=>setForm(f=>({...f,saat:e.target.value}))} />
            </div>
            <div className="form-group">
              <label className="form-label">Birim Ücret (₺/saat)</label>
              <input className="form-input" type="number" value={form.birim_ucret} onChange={e=>setForm(f=>({...f,birim_ucret:e.target.value}))} />
            </div>
            <div className="form-group" style={{gridColumn:'1/-1'}}>
              <label className="form-label">Açıklama</label>
              <input className="form-input" value={form.aciklama} onChange={e=>setForm(f=>({...f,aciklama:e.target.value}))} />
            </div>
          </div>
          {form.saat && form.birim_ucret && (
            <div style={{marginTop:8,fontFamily:'var(--font-ui)',fontWeight:800,color:'#10B981'}}>
              Toplam: {TL(parseFloat(form.saat)*parseFloat(form.birim_ucret))}
            </div>
          )}
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:14}}>
            <button className="btn btn-secondary" onClick={()=>setShowForm(false)}>İptal</button>
            <button className="btn btn-primary" onClick={handleEkle}>💾 Ekle</button>
          </div>
        </div>
      )}

      {/* Özet */}
      {ekDersler.length > 0 && (
        <div className="muh-grid-3">
          {[
            {l:'Onaylanan Toplam Saat', v:`${toplamSaat.toFixed(1)} saat`, c:'#10B981'},
            {l:'Onaylanan Hakediş',     v:TL(toplamTutar), c:'var(--blue)'},
            {l:'Bekleyen Onay',         v:`${ekDersler.filter(e=>!e.onaylandi).length} kayıt`, c:'#F59E0B'},
          ].map((s,i)=>(
            <div key={i} className="stat-card">
              <div className="stat-number" style={{color:s.c}}>{s.v}</div>
              <div className="stat-label">{s.l}</div>
            </div>
          ))}
        </div>
      )}

      {/* Tablo */}
      <div className="card animate-fadeInUp" style={{padding:0}}>
        {loading ? <div className="page-loader" style={{minHeight:200}}><div className="spinner"/></div>
        : ekDersler.length===0 ? <div className="empty-state" style={{padding:56}}><div style={{fontSize:'3rem'}}>🏫</div><h3>Ek ders kaydı yok</h3></div>
        : (
          <div className="table-container">
            <table className="table">
              <thead><tr><th>Öğretmen</th><th>Tarih</th><th>Tür</th><th style={{textAlign:'center'}}>Saat</th><th style={{textAlign:'right'}}>Birim</th><th style={{textAlign:'right'}}>Toplam</th><th>Onay</th><th></th></tr></thead>
              <tbody>
                {ekDersler.map((e,i)=>(
                  <tr key={i}>
                    <td style={{fontWeight:700}}>{e.ad} {e.soyad}</td>
                    <td style={{fontSize:'0.82rem'}}>{new Date(e.tarih).toLocaleDateString('tr-TR')}</td>
                    <td><span className="badge" style={{background:(DERS_RENK[e.ders_turu]||'#94A3B8')+'22',color:DERS_RENK[e.ders_turu]||'#94A3B8'}}>{DERS_TURU[e.ders_turu]||e.ders_turu}</span></td>
                    <td style={{textAlign:'center',fontFamily:'var(--font-ui)',fontWeight:800}}>{e.saat}</td>
                    <td style={{textAlign:'right',color:'var(--text-muted)'}}>{e.birim_ucret>0?TL(e.birim_ucret):'—'}</td>
                    <td style={{textAlign:'right',fontFamily:'var(--font-ui)',fontWeight:800,color:'#10B981'}}>{e.toplam>0?TL(e.toplam):'—'}</td>
                    <td>
                      {e.onaylandi
                        ? <span className="badge badge-success">✅ {e.onaylayan_ad||'Onaylı'}</span>
                        : <span className="badge" style={{background:'#FEF3C7',color:'#92400E'}}>⏳ Bekliyor</span>
                      }
                    </td>
                    <td>
                      {!e.onaylandi && !e.maas_id && (
                        <button className="btn btn-sm" style={{background:'#10B981',color:'white',border:'none'}}
                          onClick={()=>handleOnayla(e.id)}>✅ Onayla</button>
                      )}
                      {e.maas_id && <span style={{fontSize:'0.72rem',color:'var(--text-muted)'}}>Maaşa eklendi</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
